import { UserAvatar } from '$common/avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { nothing } from '$helper/functions/utils'
import { UserListItemBase } from './user-list-item-base'

interface Props {
  userId: string
  secondaryText?: string | JSX.Element
  selected: boolean
  hasDivider?: boolean
  onSelectedChange?: (selected: boolean) => unknown
  isPassive?: boolean
}

export function SelectableUserListItem({
  userId,
  secondaryText,
  selected,
  hasDivider,
  onSelectedChange = nothing,
  isPassive,
}: Props) {
  return (
    <UserListItemBase
      userId={userId}
      secondaryText={secondaryText}
      avatarComponent={
        <UserAvatar userId={userId} size={AvatarSize.MD} checked={selected} />
      }
      hasDivider={hasDivider}
      onClick={() => onSelectedChange(!selected)}
      isPassive={isPassive}
    />
  )
}
